import { useEffect, useState } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import City from './pages/cultural-city/CulturalCity';
import Home1 from "./pages/home/Home";
import PrivateRoute from "./Routes/PrivateRoute";
import Header from "./components/common/Header";
import Footer2 from "./components/common/Footer2";
import Footer4 from './components/common/Footer4'
import Apartment from "./pages/admin/Apartment/Apartment";
import Apartments from "./pages/Apartments/Apartments";
import Medical from "./pages/medical/Medical";
import Visa from "./pages/Visa/Visa";
import FnB from "./pages/FnB";
import Shop from "./pages/Shop";
import About from "./pages/About-Us/About";
import Terms from "./pages/TermsAndCondition/Terms";
import Bookings from "./pages/Booking/Bookings";
import Login from "./pages/admin/Login/Login";
import Dashboard from "./pages/admin/dashboard/Dashboard";
import AdminLayout from "./pages/admin/Layout/AdminLayout";
import Amenities from './pages/admin/Amenities/Amenities';
import Contacted from "./pages/admin/contacted/Contacted";
import Facility from './pages/admin/Facility-Services/Facility';
import Extra from './pages/admin/Extrra-service/Exrtra';
import Contacus from './pages/Contact-Us/Contactus';
import Booking from "./pages/Booking/Booking";

import chauff from "./assets/mobilefoot.jpg"
import india from "./assets/india.jpg"
import footer from "./assets/footer.jpg";
import foot from './assets/foot.jpg';
import book from './assets/book.jpg';
import Dental from './pages/dental/Dental'
import Chauffersection from "./pages/Chauffer/Chauffersection";
import BookTour from "./pages/cultural-city/BookTour";
import VisaApplication from './pages/Visa/VisaApplication'
import BookAppointment from './pages/medical/BookAppointment'
import DentalBooking from './pages/dental/DentalBooking'
import MedicalList from './pages/admin/Medical/Medical'
import ChaufferBooking from './pages/Chauffer/ChaufferBookings'
import VisaList from './pages/admin/Visa/Visa'
import DentalList from './pages/admin/Dental/Dental'
import balcony from './assets/apartments/lodha/IMG_9026.jpg'
import aprt from './assets/apartments/kingston/kingston.jpg'
export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  const [hasRedirected, setHasRedirected] = useState(false);

  // Optional redirect logic
  // useEffect(() => {
  //   if (!hasRedirected) {
  //     setHasRedirected(true);
  //     if (location.pathname === "/") {
  //       navigate("/login", { replace: true });
  //     }
  //   }
  // }, [hasRedirected, location.pathname, navigate]);

  const isLayoutHidden = location.pathname.startsWith("/admin") || location.pathname === "/login";

  // Corrected renderFooter function
  const renderFooter = () => {
 if (
  location.pathname === "/contact-us" ||
  location.pathname === "/terms-and-condition" ||
  location.pathname === "/visas" ||
  location.pathname === "/dental" ||
  location.pathname === '/medical' ||
  location.pathname === '/tour-booking' ||
  location.pathname === '/visa-application' ||
  location.pathname === '/book-appointment' ||
  location.pathname === '/dental-appointment' 

) {
  return <Footer2 />;
}


    let footerImage = footer;
    let footstatus = false;

    if (location.pathname === "/apartments") {
      footerImage = aprt;
    } else if (location.pathname === "/chauffeur") {
      footerImage = india;
    } else if (location.pathname === "/cultural-city") {
      footerImage = foot;
      footstatus = true;
    } else if (location.pathname === "/booking") {
      footerImage = book;
    }
    else if (location.pathname === "/") {
      footerImage = balcony;
    }

    return <Footer4 image={footerImage} footstatus={footstatus} />;
  };

  return (
    <div className="min-h-screen flex flex-col">
      {!isLayoutHidden && <Header />}

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home1 />} />
          <Route path="/apartments" element={<Apartments />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/tour-booking" element={<BookTour />} />
          <Route path="/visa-application" element={<VisaApplication />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/dental-appointment" element={<DentalBooking />} />



          <Route path="/medical" element={<Medical />} />
          <Route path="/visas" element={<Visa />} />
          <Route path="/dental" element={<Dental />} />
          <Route path="/cultural-city" element={<City />} />
          <Route path="/chauffeur" element={<Chauffersection />} />
          <Route path="/chauffeur-booking" element={<ChaufferBooking />} />
          <Route path="/fnb" element={<FnB />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/contact-us" element={<Contacus />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/terms-and-condition" element={<Terms />} />
          <Route path="/login" element={<Login />} />

          <Route element={<PrivateRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="apartment-list" element={<Apartment />} />
              <Route path="apartment-amenities" element={<Amenities />} />
              <Route path="contacted-customers" element={<Contacted />} />
              <Route path="medical-customers" element={<MedicalList />} />
              <Route path="visa-customers" element={<VisaList/>} />
              <Route path="dental-customers" element={<DentalList/>} />


              <Route path="apartment-facility" element={<Facility />} />
              <Route path="extra-service" element={<Extra />} />
            </Route>
          </Route>
        </Routes>
      </main>

      {!isLayoutHidden && renderFooter()}
    </div>
  );
}
